import React from "react";
import Slider from "react-slick";
import { FaQuoteLeft, FaStar } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const testimonialsData = [
  { name: "Sarah K.", role: "Client", message: "Abdullah created a professional website for our business. The results were phenomenal!", rating: 5 },
  { name: "Ali R.", role: "Client", message: "Thanks to the paid ad campaigns, our sales doubled. Highly skilled and reliable.", rating: 5 },
  { name: "Hamza S.", role: "Client", message: "Creative logos and branding gave our brand a unique identity. Great work!", rating: 5 },
  { name: "Zara A.", role: "Client", message: "Very cooperative and delivered the project before the deadline. Impressed with the quality!", rating: 5 },
  { name: "Usman T.", role: "Client", message: "Amazing design sense and strong communication. Highly recommended for startups.", rating: 5 },
  { name: "Maya L.", role: "Client", message: "Our online store got a fresh new look — user-friendly and fast. Excellent experience!", rating: 5 },
];

export default function Testimonials() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992, // tablet
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576, // mobile
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false, // mobile pe clean look
        },
      },
    ],
  };

  return (
    <section
      id="testimonials"
      className="py-5"
      style={{ background: "#162447", color: "#fff" }}
    >
      <div className="container text-center">
        <h2 className="fw-bold mb-4">Testimonials</h2>
        <div
          className="mx-auto mb-5"
          style={{
            width: "80px",
            height: "3px",
            background: "linear-gradient(135deg, #ff4e50, #f9d423)",
            borderRadius: "2px",
          }}
        ></div>

        <Slider {...settings}>
          {testimonialsData.map((testimonial, idx) => (
            <div key={idx} className="px-2">
              <div
                className="p-4 rounded-4 h-100"
                style={{
                  background: "#1a1a2e",
                  minHeight: "230px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ position: "relative" }}>
                  <FaQuoteLeft
                    size={20}
                    style={{
                      position: "absolute",
                      top: "-10px",
                      left: "-5px",
                      color: "#ff4e50",
                    }}
                  />
                  <p className="mt-3">{testimonial.message}</p>
                </div>
                <div>
                  <div className="mt-3">
                    {Array.from({ length: testimonial.rating }).map((_, i) => (
                      <FaStar key={i} color="#f9d423" />
                    ))}
                  </div>
                  <h6 className="fw-bold mt-3 mb-0">{testimonial.name}</h6>
                  <small style={{ color: "#d1d1d1" }}>{testimonial.role}</small>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}
